
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/debt-consolidation-calculator",
      function () {
        return require("private-next-pages/tools/debt-consolidation-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/debt-consolidation-calculator"])
      });
    }
  